import { Button, Card, Col, Form } from "react-bootstrap";
import { ButtonRemover, ButtonTrash, JRow, JTable, JTBody, JTHead, JvCaption } from "../../../components/Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { infEmbCombInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useEffect, useRef, useState } from "react";
import { formatMoeda, getUuidV4, goToFocus } from "../../../utils/utils";
import { addComboio, removeComboio, removeComboioTodos } from "../../../features/manifestoSlice";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";

const LIMITE: number = 30;

const initialState: infEmbCombInterface = {
    id: 0,
    cembcomb: '',
    xbalsa: ''
}

export default function EmbarcacaoComboio() {
    const [selecionado, setSelecionado] = useState<number | string>('');
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_aquatico.infEmbComb);
    const [form, setForm] = useState<infEmbCombInterface>(initialState);
    const codEmbarcacao = useRef<HTMLInputElement>(null)
    const nomeBalsa = useRef<HTMLInputElement>(null)
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { confirm, ConfirmModal } = useQuestion();
    const [saldo, setSaldo] = useState<number>(0);

    const validaPreenchimento = () => {
        if (form.cembcomb.toString() === "") {
            goToFocus(codEmbarcacao);
            alertModal('Informe o Código da Embarcação');
            return false;
        }

        if (form.xbalsa.toString() === "") {
            goToFocus(nomeBalsa);
            alertModal('Informe o nome da balsa');
            return false;
        }

        if (lista.length >= LIMITE) {
            alertModal(`Limite de ${formatMoeda(LIMITE, 0)} terminais atingido.`);
            return false;
        }

        if (lista.find((item: infEmbCombInterface) => item.cembcomb.trim() === form.cembcomb.trim())) {
            alertModal('Código da embarcação já adicionado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addComboio({ ...form, id: getUuidV4() }))
            setForm(initialState);
            goToFocus(codEmbarcacao);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover Cod. Embarcação: <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeComboio(value.id));
        }
        setSelecionado('')
    }

    const handleRemoverTodos = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeComboioTodos());
            }
        }
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        setSaldo(lista.length);
    }, [lista])

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header>Informações dos terminais de carregamento <span
                className="text-primary fw-semibold">(Opcional)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md={2}>
                        <Form.Group controlId="aquav-embcom-cembcomb">
                            <Form.Label>Código da Embarcação</Form.Label>
                            <Form.Control type="text" name="cembcomb"

                                title="Código da embarcação"
                                maxLength={10} value={form.cembcomb}
                                ref={codEmbarcacao}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="aquav-embcom-xbalsa">
                            <Form.Label>Identificador da Balsa</Form.Label>
                            <Form.Control type="text" name="xbalsa"

                                title="Identificador da balsa"
                                maxLength={60} value={form.xbalsa}
                                ref={nomeBalsa}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">
                        <Button variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    </Col>
                </JRow>

                <JTable>
                    <JvCaption>({saldo} de {LIMITE} no máximo)</JvCaption>
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '4rem' }}>
                                <ButtonTrash onClick={() => handleRemoverTodos()} />
                            </th>
                            <th className="text-center" style={{ width: '11rem' }}>Cód. Embarcação</th>
                            <th className="text-center" >Identificador da Balsa</th>
                        </tr>
                    </JTHead>

                    <JTBody>
                        {lista?.map((item: infEmbCombInterface) => (
                            <tr key={item.id}
                                className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center">
                                    <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.xbalsa })} />
                                </td>
                                <td className="text-center">{item.cembcomb}</td>
                                <td className="text-center">{item.xbalsa}</td>

                            </tr>
                        ))}
                    </JTBody>
                </JTable>

            </Card.Body>
        </Card>

        {ModalMessageEl}
        {ConfirmModal}
    </>)
}